import React, { useCallback, useEffect, useState } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { compose } from "recompose";
import { isLoading } from "@worcket/common/hocs";

import {
  FETCH_OPPORTUNITIES,
  fetchOpportunities
} from "../../../../store/actions/opportunities";
import SelectDataModal from "../../../../components/SelectDataModal";

function ShareCandidatesModal({
  fetchOpportunities,
  loading,
  onClose,
  onOk,
  opportunities,
  visible
}) {
  const { t } = useTranslation();
  const [opportunitiesData, setOpportunitiesData] = useState([]);

  useEffect(() => {
    if (opportunities === null && !loading) fetchOpportunities();
  }, [fetchOpportunities, loading, opportunities]);

  useEffect(() => {
    if (
      R.isEmpty(opportunitiesData) &&
      R.not(R.isEmpty(opportunities)) &&
      visible
    )
      setOpportunitiesData(
        R.map(
          R.compose(
            R.assoc("checked", false),
            opportunity =>
              R.compose(
                R.assoc("testKey", `share-opportunity-${opportunity.id}`),
                R.assoc("description", `ID: ${opportunity.id}`)
              )(opportunity),
            R.pick(["id", "title"])
          ),
          opportunities
        )
      );
  }, [opportunities, opportunitiesData, visible]);

  useEffect(() => {
    if (!visible && R.not(R.isEmpty(opportunitiesData)))
      setOpportunitiesData([]);
  }, [opportunitiesData, visible]);

  const handleChange = useCallback(({ id, checked }) => {
    setOpportunitiesData(
      R.map(R.when(R.propEq("id", id), R.assoc("checked", !checked)))
    );
  }, []);

  const handleOnOk = useCallback(() => {
    onOk(R.filter(R.prop("checked"), opportunitiesData));
    onClose();
  }, [onClose, onOk, opportunitiesData]);

  return (
    <SelectDataModal
      cancelButtonProps={{
        "data-test": "close-share-candidates-modal-button"
      }}
      data={opportunitiesData}
      emptyText={t("components:ShareCandidatesModal.empty")}
      loading={loading}
      onCancel={onClose}
      onChange={handleChange}
      okButtonProps={{
        "data-test": "share-candidates-to-opportunity-button"
      }}
      onOk={handleOnOk}
      searchProps={["title"]}
      title={t("components:ShareCandidatesModal.title")}
      visible={visible}
    />
  );
}

const mapStateToProps = state => ({
  opportunities: R.when(
    Array.isArray,
    R.filter(
      R.converge(R.and, [
        R.propEq("status", "published"),
        R.compose(
          R.not,
          R.propEq("id", R.path(["opportunity", "selected", "id"], state))
        )
      ])
    ),
    state.opportunities.list
  )
});

export default compose(
  connect(
    mapStateToProps,
    {
      fetchOpportunities
    }
  ),
  isLoading(FETCH_OPPORTUNITIES)
)(ShareCandidatesModal);
